import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ActivitiesService {
  private refreshActivitiesSource = new Subject<void>();
  refreshActivities$ = this.refreshActivitiesSource.asObservable();

  triggerRefresh() {
    this.refreshActivitiesSource.next();
  }

  private ngt18Url: string = environment.API_URL + 'main/';

  constructor(private http: HttpClient) {
  }

  getActivities(data) {
    return this.http.post(this.ngt18Url + "module.p2p.getApplicationEvents", data);
  }

  updateApplicationEventReadStatus(data) {
    return this.http.post(this.ngt18Url + "module.p2p.updateApplicationEventReadStatus", data);
  }

  markAllApplicationEventsAsReadDirect(data) {
    return this.http.post(this.ngt18Url + "module.p2p.markAllApplicationEventsAsReadDirect", data);
  }

  getNotificationUpdate(data) {
    return this.http.post(this.ngt18Url + "module.ams.notificationUpdate", data);
  }

  getCurrentStep(data) {
    return this.http.post(this.ngt18Url + 'module.ams.currentStep', data);
  }

  getSuppliersList(dataParam) {
    return this.http.post(this.ngt18Url + 'module.p2p.getSuppliers', dataParam);
  }

  getUsers(dataParam) {
    return this.http.post(this.ngt18Url + 'module.vew.listUser', dataParam);
  }

}
